import { combineReducers } from 'redux'
import plan from './plan/reducer'
import plans from './plans/reducer'
import properties from './properties/reducer'
import savings from './savings/reducer'
import income from './income/reducer'
import events from './events/reducer'
import expenses from './expenses/reducer'
import vacations from './vacations/reducer'
import renovations from './renovations/reducer'
import activities from './activities/reducer'
import debts from './debts/reducer'
import report from './report/reducer'
import stats from './stats/reducer'

export const futurechoices = combineReducers({
  plan,
  plans,
  properties,
  savings,
  income,
  events,
  expenses,
  vacations,
  renovations,
  activities,
  debts,
  report,
  stats
})
